module.exports = __webpack_public_path__ + "static/media/eccv_teaser_final_corrected.80948f1e.mp4";